// extracted by mini-css-extract-plugin
module.exports = {"container":"vNBy5","authorInfo":"_3D5dp","authorPicture":"arVVA","name":"_13_BW","username":"_1s0vM","content":"R6vW4"};